import { render, staticRenderFns } from "./ComparePagination.vue?vue&type=template&id=f616580c&"
import script from "./ComparePagination.vue?vue&type=script&lang=ts&"
export * from "./ComparePagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports